import { useState, useRef, useEffect } from "react";

/**
 * @param {number} [topThreshold=10] — scrollY <= topThreshold is considered "at top"
 * @returns {{ isAtTop: boolean, isVisible: boolean }}
 */
export function useScrollHeader(topThreshold = 10) {
  const [isAtTop, setIsAtTop] = useState(true);
  const [isVisible, setIsVisible] = useState(true);

  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const y = window.scrollY;
    lastScrollY.current = y;
    setIsAtTop(y <= topThreshold);
    setIsVisible(y <= topThreshold);
  }, [topThreshold]);

  useEffect(() => {
    const handleScroll = () => {
      if (ticking.current) return;
      ticking.current = true;

      requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const scrollDelta = currentScrollY - lastScrollY.current;

        const atTop = currentScrollY <= topThreshold;
        setIsAtTop(atTop);

        if (atTop) {
          setIsVisible(true);
        } else {
          if (scrollDelta > 5) {
            setIsVisible(false);
          } else if (scrollDelta < -5) {
            setIsVisible(true);
          }
        }

        lastScrollY.current = currentScrollY;
        ticking.current = false;
      });
    };

    lastScrollY.current = window.scrollY;
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [topThreshold]);

  return { isAtTop, isVisible };
}
